//@flow
import React from 'react';
import type {Node} from 'react';

import makeStyles from '@material-ui/core/styles/makeStyles';

type Props = {
  label?: string,
  onClick?: () => void,
  children?: Node,
  className?: string,
};

const useStyles = makeStyles(theme => ({
  btn: {
    background:
      'conic-gradient(from 180deg at 50% 50%, #7a37ff 0deg, #ffc83b 200.63deg,#7a37ff 360deg)',
    borderRadius: '32px',
    border: 'none',
    padding: 2,
    display: 'flex',
  },
  content: {
    background: 'linear-gradient(95.32deg, #7b39ff -25.42%, #18003d 51.6%)',
    borderRadius: 'inherit',
    width: '100%',
    height: '100%',
    padding: '8px 12px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
}));

export default function GradientButton(props: Props) {
  const {label, onClick, children, className} = props;

  const classes = useStyles();

  return (
    <button
      className={`${classes.btn} ${className ? className : ''}`}
      onClick={onClick}
    >
      <span className={classes.content}>{!children ? label : children}</span>
    </button>
  );
}
